import * as Actions     from '../actions/creators';
import Validation       from '../../../common/utils/validation'

class Blog {
    constructor(props, componentProps, dispatch, selectors, t, redux = {}) {
        this.name               = 'Blog';
        this.props              = props;
        this.dispatch           = dispatch;
        this.componentProps     = componentProps;
        this.redux              = redux;
        this.t                  = t;
        this.selectors          = selectors;

        if (props && props.onMount) {
            this.onMount()
        }
    }

    onMount() {
        this.props.onMount();
    }

    addBlog(state) {
        this.dispatch(Actions.addBlog(state));
    }

    updateBlog(payload) {
        this.dispatch(Actions.updateBlog(payload));
    }

    getBlog(payload) {
        this.dispatch(Actions.getBlog({ payload }));
    }

    getBlogDetails(payload) {
        this.dispatch(Actions.getBlogDetails(payload));
    }
    
    clearBlogDetails() {
        this.dispatch(Actions.clearBlogDetails());
    }

    removeBlog(payload) {
        this.dispatch(Actions.removeBlog(payload));
    }
}

export default Blog;